import React from "react";
import { motion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "@/lib/motion";
import { PrimaryCTA } from "@/components/CTA";

const PORTRAIT = "https://customer-assets-jt897jd0.emergentagent.net/job_proprietari-salento/artifacts/3wyvlywg_C799A4AF-CB37-4A81-ADC3-A2D26770A746.PNG";

export const ChiSono = () => (
  <section id="chi-sono" data-testid="section-chi-sono" className="bg-white py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 md:grid-cols-12 md:gap-16 md:px-12">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={viewportOnce}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative md:col-span-5"
      >
        <div className="relative overflow-hidden rounded-[2rem] rounded-tr-none border border-navy/10">
          <img
            src={PORTRAIT}
            alt="Ritratto di Alessandro Bascià, fondatore di Alba Selection"
            className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent" />
        </div>
        <div className="absolute -bottom-5 -left-5 rounded-2xl bg-gold px-6 py-4 shadow-[0_16px_40px_rgba(201,162,39,0.35)]">
          <div className="font-display text-3xl font-semibold leading-none text-navy-deep">2012</div>
          <div className="mt-1 text-xs uppercase tracking-widest text-navy-deep/70">dal 2012 nel settore</div>
        </div>
      </motion.div>

      <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={viewportOnce} className="md:col-span-7">
        <motion.p variants={fadeUp} className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-gold">
          Chi c'è dietro
        </motion.p>
        <motion.h2 variants={fadeUp} className="font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
          Alba Selection è Alessandro Bascià.
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-7 text-base leading-relaxed text-text-muted sm:text-lg">
          Gestisco strutture ricettive nel Salento dal 2012. In questi anni ho imparato una cosa
          semplice: il territorio non si gestisce da un pannello nazionale. Conoscere la differenza tra
          un'unità a Gallipoli e una a Pescoluse, sapere quando il mercato inizia a muoversi, capire chi
          prenota e quando — questo fa la differenza sul prezzo. Lavoro in prima persona, con un metodo
          basato sui dati e non sulle sensazioni.
        </motion.p>
        <motion.p variants={fadeUp} className="mt-5 text-base leading-relaxed text-navy sm:text-lg">
          «Alba» non è solo un marchio: sta per <span className="font-semibold text-gold">AL</span>essandro{" "}
          <span className="font-semibold text-gold">BA</span>scià. È il mio nome, ed è la mia firma su
          ogni struttura che gestisco.
        </motion.p>
        <motion.div variants={fadeUp} className="mt-9">
          <PrimaryCTA testId="chisono-cta">Parliamo del tuo immobile</PrimaryCTA>
        </motion.div>
      </motion.div>
    </div>
  </section>
);
